import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { debouncePE } from '../../utils/helper';
import './index.scss';

const initialState = {
  activeIndex: -1,
  options: [],
  q: '',
  loading: -1
}

class DropdownInput extends Component {
  static propTypes = {
    loadOptions: PropTypes.func,
    onSelect: PropTypes.func.isRequired,
    value: PropTypes.object,
    className: PropTypes.string,
    emptyText: PropTypes.string,
    options: PropTypes.array,
    isOpen: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    emptyText: 'No options',
    options: [],
    isOpen: false,
    value: {},
  };

  constructor(props) {
    super(props);
    this.state = { ...initialState, options: props.options };
  }

  componentDidMount() {
    const { value: initialValue ={} } = this.props;
    this.setActiveIndex(initialValue.value);
    this.setState({
      q: initialValue.label
    });
  }

  selectIndex = (selectedIndex) => {
    const { options } = this.state;
    const selectedOption = options[selectedIndex]
    this.setState({ ...initialState, q: selectedOption.label });
    this.props.onSelect(selectedOption);
    this.inputRef && this.inputRef.blur();
  }

  loadOptionsFromQuery = (q) => {
    const { loadOptions } = this.props;
    this.setState({ q, loading: 1 });
    if (!q) {
      return;
    }
    debouncePE(500, () => {
      loadOptions(q).then((options) => this.setState({ loading: 0, options, activeIndex: 0 }));
    });
  }

  handleInputChange = (q) => {
    const { loadOptions } = this.props;
    if (loadOptions) {
      this.loadOptionsFromQuery(q);
      return;
    }

    this.setState({ q }, () => this.setActiveIndex(q));
  }

  setActiveIndex = (value) => {
    let { options, q = '' } = this.state;
    q = String(q);
    const newActiveIndex = options.findIndex(option => option.value == value);
    const defaultIndex = q && q.length ? options.length - 1 : -1;
    this.setState({ activeIndex: newActiveIndex > -1 ? newActiveIndex : defaultIndex }, () => this.scrollToActiveIndex());
  }

  handleKeyPress = (e) => {
    const { pattern } = this.props;
    let { activeIndex, options = [] } = this.state;
    if (!options.length) {
      return;
    }

    if (pattern && e.key && (e.key.length === 1) && !e.key.match(pattern)) {
      e.preventDefault();
      return false;
    }

    switch (e.which) {
      case 13: // Return
        this.selectIndex(activeIndex);
        break;
      case 38: // UP Arrow
        if (activeIndex <= 0) {
          break;
        }
        this.setState({ activeIndex: --activeIndex, q: options[activeIndex].label });
        break;
      case 40: // DOWN Arrow
        if (activeIndex === options.length - 1) {
          break;
        }
        this.setState({ activeIndex: ++activeIndex, q: options[activeIndex].label });
        break;
      default:
        return;
    }

    this.scrollToActiveIndex();

    return true;
  }

  scrollToActiveIndex = () => {
    if (!this.inputRef) {
      return;
    }

    const containerNode = this.inputRef.closest('.DropdownInputContainer');
    const elementNode = containerNode.querySelectorAll('.resultItem.active')[0];
    const resultContainer = containerNode.getElementsByClassName('resultContainer')[0];
    if (resultContainer) {
      resultContainer.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'nearest'});
    }
    if (elementNode) {
      elementNode.parentNode.scrollTop = elementNode.offsetTop - elementNode.scrollHeight;
    }
  }

  handleOnFocus = () => {
    const { options, value: selectedOption } = this.props;
    if (options.length) {
      this.setState({ options});
    }
    if (selectedOption && selectedOption.value) {
      this.setActiveIndex(selectedOption.value);
      return;
    }
    this.scrollToActiveIndex();
  }

  componentDidUpdate = (prevProps) => {
    const { value: initialValue ={}, isOpen } = this.props;
    const { value: prevValue ={} } = prevProps;
    if (initialValue == prevValue) {
      return;
    }
    this.setActiveIndex(initialValue.value);
    this.setState({
      q: initialValue.label
    });

    if (isOpen) {
      this.inputRef && this.inputRef.focus();
    }
  }

  render() {
    const { activeIndex, options = [], q, loading } = this.state;
    const {
      value: initialValue,
      className,
      placeholder,
      emptyText,
    } = this.props;
    const emptyOptions = (loading != -1) && !options.length;
    let loadingText = options.length ? '' : emptyText;
    loadingText = loading === 1 ? 'Processing...' : loadingText;
    loadingText = q ? loadingText : 'Start Typing!!';
    return (
      <div className={`DropdownInputContainer ${className}`}>
        <input type="hidden" value="something"/>
        <input
          onChange={(e) => this.handleInputChange(e.target.value)}
          className="inputBox"
          placeholder={placeholder ? placeholder : 'Start typing...'}
          onKeyDown={this.handleKeyPress}
          value={q}
          onBlur={() => this.setState({ q: initialValue.label || ''})}
          onFocus={this.handleOnFocus}
          ref={e => { this.inputRef = e; }}
          autoComplete="none"
        />
        <i onClick={() => this.inputRef && this.inputRef.focus()} className="material-icons chevronDown">expand_more</i>
        <ul className="resultContainer">
          {options.map(({label, subText}, index) => (<li className={cx('resultItem', {'active': index === activeIndex})} key={index} onClick={() => this.selectIndex(index)}>
              {label}
              {subText && <span className="subText">{subText}</span>}
            </li>))}
          {((loading === 1) || emptyOptions) && (<div className="loading">{loadingText}</div>)}
        </ul>
      </div>
    );
  }
}

export default DropdownInput;
